import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["day", "cellContent"]

  initialize() {
    const today = new Date()

    this.dayTargets.forEach((dayTarget) => {
      const [yyyy, mm, dd] = dayTarget.dataset["date"].split("-")
      const date = new Date(yyyy, mm - 1, dd)
      const isToday = (date.toDateString() === today.toDateString())

      if (isToday) {
        dayTarget.classList.add("day-today")
      }
    })
  }

  toggleCellContent(e) {
    const cellLink = e.target.closest("a[data-cell-content-id]")
    const selectedCellContentId = cellLink.dataset.cellContentId
    e.preventDefault()

    hideElement(this.cellContentTargets)
    const selectedCellContent = document.getElementById(selectedCellContentId)

    showElement(selectedCellContent)
  }
}
